import './../Event.css';
import React from 'react';
import { Grid } from '../../../../../components/Grid/Grid';
import { Event, getEventDetails } from '../../../../../model/event';
import { ShopCategories } from './ShopCategories';
import { CheckoutOptions } from './CheckoutOptions';
import { ShippableFrom } from './ShippableFrom';
import { MassRefund } from './MassRefund';
import { Meta } from '../../../../../components/meta/meta';
import { Stack } from '../../../../../components/Stack/Stack';
import { EventImage } from './EventImage';

export function Shop({ event }: { event: Event }): JSX.Element {
  return (
    <Stack className="event-shop" size="lg">
      <Grid>
        <ShopCategories product={event} onChange={async () => await getEventDetails({ eventId: event.id })} />
        <CheckoutOptions product={event} productType="event" />
        <ShippableFrom event={event} />
        <MassRefund event={event} />
      </Grid>
      <Meta id={event.id} type="product" />
      <Grid>
        <EventImage product={event} />
      </Grid>
    </Stack>
  );
}
